import { type PartialSpecificAddonCartItem, type SpecificAddonCartItem, type CartItem, type PartialCartItem } from '../types'

export const validateCartItem = (item: PartialCartItem): item is CartItem => {
  const { cartItemId } = item
  if (!cartItemId) {
    console.error(`Invalid params ${JSON.stringify(item)}`)
    return false
  }
  return true
}

export const validateSpecificAddonCartItems = (items: PartialSpecificAddonCartItem[]): items is SpecificAddonCartItem[] => {
  return items.every(item => validateCartItem(item))
}

export const validateSpecificAddonCartItem = (item: PartialSpecificAddonCartItem): item is SpecificAddonCartItem => {
  const { cartItemId } = item
  if (!cartItemId) {
    console.error(`Invalid params ${JSON.stringify(item)}`)
    return false
  }
  return true
}
